<template>
    <el-card class="operation-container noBorder">
        <Transition name="fade">
            <el-form
                v-if="formVisible"
                :inline="true"
                label-position="top"
                class="search-form"
                :model="search_data"
                style="padding: 0"
            >
                <el-form-item label="用户名称">
                    <el-input v-model="search_data.number" clearable placeholder="请输入用户名称" style="width: 170px" />
                </el-form-item>
                <el-form-item label="用户姓名">
                    <el-input v-model="search_data.name" clearable placeholder="请输入姓名" style="width: 170px" />
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input v-model="search_data.telephone" clearable placeholder="请输入手机号码" style="width: 170px" />
                </el-form-item>
                <el-form-item label="是否导入">
                    <el-select v-model="search_data.is_import" clearable placeholder="请选择" style="width: 170px">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
        </Transition>
        <div style="display: flex; margin-bottom: 10px">
            <el-button type="primary" :icon="Download" v-permission="['syncuser:sync']" @click="onBatchSync()">
                批量导入
            </el-button>
            <div class="card-header" style="margin-left: auto">
                <div class="circle-btn">
                    <el-tooltip class="box-item" effect="dark" :content="formVisible ? '隐藏搜索' : '显示搜索'" placement="top">
                        <el-button plain circle @click="formVisible = !formVisible" :icon="Search" size="small"></el-button>
                    </el-tooltip>
                    <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                        <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                    </el-tooltip>
                </div>
            </div>
        </div>

        <el-table
            ref="multipleTableRef"
            :data="table_data"
            v-loading="tableLoading"
            @selection-change="handleSelectionChange"
            style="width: 100%"
            border
        >
            <el-table-column type="selection" :selectable="selectable" width="55" />
            <el-table-column label="序号" type="index" width="60" />
            <el-table-column prop="user_number" label="用户名称"></el-table-column>
            <el-table-column prop="user_name" label="姓名"></el-table-column>
            <el-table-column prop="dept_name" label="部门"></el-table-column>
            <el-table-column prop="telephone" label="手机号码"></el-table-column>
            <el-table-column prop="create_time" label="同步时间" sortable></el-table-column>
            <el-table-column prop="is_import" label="是否导入">
                <template #default="{ row }">
                    <span :style="{ color: row.is_import ? '#67c23a' : '#f56c6c' }">
                        {{ row.is_import ? '已导入' : '未导入' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template #default="{ row }">
                    <el-button type="primary" link :icon="View" @click="onShowClick(row)" v-permission="['syncuser:view']">
                        详情
                    </el-button>
                    <el-button
                        type="primary"
                        link
                        :icon="Download"
                        @click="onSyncClick(row)"
                        v-if="!row.is_import"
                        v-permission="['syncuser:sync']"
                    >
                        导入
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search_data.page"
            :page-sizes="[10, 20, 50]"
            :page-size="search_data.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
        <Sync-dialog
            v-model="syncDialogVisible"
            :userList="selectUserList"
            :isSync="isSync"
            :deptList="deptList"
            @updateForm="getTableData"
        ></Sync-dialog>
        <view-dialog v-model="viewDialogVisible" :user_id="selectId" @updateForm="getTableData"></view-dialog>
    </el-card>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { getSyncUserLists } from '@/api/sync-users.js'
import { getDepartmentTree } from '@/api/dept.js'
import { cloneDeep } from 'lodash'
import { Download, Refresh, Search, View } from '@element-plus/icons'
import ViewDialog from './components/viewDialog.vue'
import SyncDialog from './components/syncDialog.vue'
import { ElMessage } from 'element-plus'
// 数据源
const search_data = ref({
    username: '',
    name: '',
    telephone: '',
    page: 1,
    page_size: 10,
    is_import: ''
})
const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)
const statusOptions = [
    { label: '已导入', value: 1 },
    { label: '未导入', value: 0 }
]
// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)

// 处理搜索数据
const getPostFormData = (data) => {
    if (!data.is_import) {
        delete data.is_import
    }
    return data
}

// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    const res = await getSyncUserLists(getPostFormData({ ...search_data.value }))
    tableLoading.value = false
    table_data.value = res.lists
    total.value = res.total
}
getTableData()

// 处理已经导入的人不可选中
const selectable = (row, index) => {
    return !row.is_import
}

const viewDialogVisible = ref(false)
const selectId = ref('') // 点中的选中人员的
// 保证每次打开重新获取数据
watch(viewDialogVisible, (val) => {
    if (!val) {
        selectId.value = ''
    }
})

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    search_data.value.page_size = currentSize
    getTableData()
}
// 页码改变触发
const handleCurrentChange = (currentPage) => {
    search_data.value.page = currentPage
    getTableData()
}

// 查看详情
const onShowClick = (row) => {
    selectId.value = row.user_id
    viewDialogVisible.value = true
}

// 部门列表
const deptList = ref([])
// 获取数据的方法
const getDeptListData = async () => {
    deptList.value = await getDepartmentTree()
}

// 选中的表格
const multipleSelection = ref()
const handleSelectionChange = (val) => {
    multipleSelection.value = val
}
const isSync = ref()
// 批量导入
const syncDialogVisible = ref(false)
const selectUserList = ref([])
const onBatchSync = () => {
    if (multipleSelection.value?.length) {
        isSync.value = true
        selectUserList.value = cloneDeep(multipleSelection.value)
        syncDialogVisible.value = true
    } else {
        ElMessage.error('请选择先需要导入的人员')
    }
}

// 人员导入
const onSyncClick = (row) => {
    isSync.value = true
    selectUserList.value = [{ ...row }]
    syncDialogVisible.value = true
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getDeptListData()
    getTableData()
})
</script>

<style lang="scss" scoped>
.header {
    margin-bottom: 20px;
}
</style>
